import React from 'react'
import styled from 'styled-components'

import Image from '../../atoms/Image'
import InstagramCampaign from '../../organisms/InstagramCampaign'
import OuterLink from '../../atoms/OuterLink'

const Container = styled.aside`
  margin-right: auto;
  width: 200px;
  @media (max-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    display: none;
  }
`

const ShareButton = styled(OuterLink)`
  display: block;
  margin: 10px auto 0;
  text-decoration: none;
  width: 160px;
`

export default function Right() {
  return (
    <Container>
      <Image filename="balloon-share.png" />
      <ShareButton
        to={`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent('https://award.mamari.jp')}`}
      >
        <Image filename="share-line.png" />
      </ShareButton>
      <ShareButton
        to={`https://twitter.com/share?url=${encodeURIComponent('https://award.mamari.jp')}&text=${encodeURIComponent(
          '【#ママリ口コミ大賞 結果発表】4,067件の口コミの中から選び抜かれた育児アイテム・サービスを発表！先輩ママの最新レビューと評判をチェック→'
        )}`}
      >
        <Image filename="share-twitter.png" />
      </ShareButton>

      <InstagramCampaign />
    </Container>
  )
}
